import React, {ComponentPropsWithRef, forwardRef} from 'react';
import {UseMutationResult, UseQueryResult} from '@tanstack/react-query';
import {Icon, NavLink} from 'components';
import {noop} from 'lodash';
import css from './button.module.scss';
import {WithClassName} from 'types';

interface Props extends WithClassName<ComponentPropsWithRef<'button'>> {
  href?: string;
  icon?: string;
  mutation?: UseMutationResult<any, any, any>;
  pressed?: boolean;
  query?: UseQueryResult<any, any>;
  rightIcon?: string;
  tagName?: string;
  to?: string;
}

export const Button = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const {tagName = 'button', type = 'button', className = 'secondary', icon, rightIcon, pressed, mutation, query, children, ...rest} = props;
  const Component = rest.href ? 'a' : rest.to ? NavLink : tagName;
  let loading = false;

  if (mutation?.isPending || query?.isFetching) {
    loading = true;
    rest.onClick = noop;
  } else if (mutation) {
    rest.onClick = mutation.mutate;
  } else if (query) {
    rest.onClick = () => query.refetch();
  }

  return (
    <Component ref={ref} type={type} className={css('button', className, icon && !children && 'has-only-icon')} aria-pressed={Boolean(pressed)} aria-busy={rest.loading} {...rest} >
      {icon && <Icon name={loading ? 'spinner' : icon} {...(typeof icon == 'object' ? icon : undefined)} />}
      {children}
      {rightIcon && <Icon name={rightIcon} />}
    </Component>
  );
});

Button.Back = function Back({children = 'Back', ...props}) {
  return (
    <Button to="../" {...props} icon="return">
      {children}
    </Button>
  );
}
